"use client";

import CardGrid from "@/components/card-grid/card-grid";
import FilterBar from "@/components/filter-bar/filter-bar";
import { getChannelContent } from "@/lib/api/channel/content-grid";
import { BProgress } from "@bprogress/core";
import Image from "next/image";
import { useEffect, useState } from "react";
import useSWR from "swr";
import Loading from "../_partials/loading/loading";

const ChannelInfo = ({
	channel,
	sorts,
	initialContents,
	initialPage,
	initialSearchTerm,
	initialGenre,
	initialSort,
	kind,
}: {
	channel: any;
	sorts: any[];
	initialContents: any;
	initialSearchTerm?: any;
	initialGenre?: any;
	initialSort?: any;
	initialPage?: string;
	kind: any;
}) => {
	const [selectedGenre, setSelectedGenre] = useState(initialGenre ?? undefined);
	const [searchTerm, setSearchTerm] = useState(initialSearchTerm || "");
	const [page, setPage] = useState(initialPage ?? "1");
	const [selectedSort, setSelectedSort] = useState(initialSort ?? undefined);

	const {
		data: contents,
		mutate,
		isLoading,
	} = useSWR(
		[
			"channel-content",
			channel?.id,
			searchTerm,
			selectedSort?.value,
			selectedGenre?.id,
			page,
		],
		() =>
			getChannelContent(
				kind.kind,
				channel?.id,
				searchTerm,
				selectedGenre?.id,
				selectedSort,
				page,
			),
		{ fallbackData: initialContents, revalidateOnMount: false },
	);

	useEffect(() => {
		const query = new URLSearchParams();
		searchTerm && query.append("title", searchTerm);
		page && query.append("page", page);
		selectedGenre && query.append("genres", selectedGenre.id);
		if (selectedSort) {
			query.append("sortBy", selectedSort.sortBy);
			query.append("direction", selectedSort.direction);
		}

		const qs = query.toString();
		const newUrl = qs
			? `${window.location.pathname}?${qs}`
			: window.location.pathname;

		window.history.replaceState(null, "", newUrl);

		mutate();
	}, [searchTerm, selectedSort, selectedGenre, page, mutate]);

	return (
		<>
			<div className="w-full text-white py-6 px-6 lg:px-[80px] flex flex-col items-start">
				<div className="w-full py-6 rounded-lg shadow-lg flex flex-col justify-between lg:flex-row gap-4">
					<div className="lg:w-2/3 py-6 flex flex-col gap-4">
						<h1
							className="text-[35px] md:text-[48px] font-extraBold text-right"
							dir="ltr"
						>
							{channel?.name}
						</h1>
					</div>
					<div className="w-full lg:w-[376px] flex justify-center flex-col items-center">
						<div className={"w-full lg:w-[376px]"}>
							{channel?.logo?.code ? (
								<Image
									src={process.env.NEXT_PUBLIC_FILE_URL + channel?.logo?.code}
									alt={channel?.name}
									width={376}
									height={526}
									layout="responsive"
									className={"rounded-lg max-w-[376px] m-auto min-w-[376px]"}
								/>
							) : null}
						</div>
					</div>
				</div>
				<div className="w-full flex flex-wrap justify-between items-center py-8 gap-4">
					<h2 className="text-white text-[32px] font-bold">آثار</h2>
					<FilterBar
						showSearch={true}
						showSort={true}
						showGenre={false}
						searchTerm={searchTerm}
						setSearchTerm={setSearchTerm}
						initialSorts={sorts}
						setSort={setSelectedSort}
						setGenre={setSelectedGenre}
					/>
				</div>
				{isLoading ? (
					<div className="w-full h-full min-h-screen flex justify-center items-center">
						<Loading />
					</div>
				) : (
					<CardGrid
						data={contents}
						kind={kind.kind}
						page={page}
						setPage={setPage}
					/>
				)}
			</div>
		</>
	);
};

export default ChannelInfo;
